import axios from 'axios';

export default async function CheckClientInstall() {
  let result;
  try {
    await axios.post(`http://localhost:61811/`).then((res) => {
      if (res.status === 200) {
        result = true;
      }
    });
  } catch (e) {
    result = false;
  }
  return result;
}
